// React
import React, { useState, useContext, useEffect } from 'react';
import useQuery from '../../utils/hook/useQuery';
import { Link } from 'react-router-dom';
// store management
import AuthContext, { AuthConsumer } from '../../authContext';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';
import {
    makeSelectLoading,
    makeSelectError,
    makeSelectCountList, makeSelectList

} from '../parcels/parcelsSaga/selectors';
import {
    getParcelsAction
} from '../parcels/parcelsSaga/actions';
import { Store } from '../../redux/reducers';
// UI
// import clsx from 'clsx';
import { makeStyles, createStyles, Theme } from '@material-ui/core/styles';
import { Grid, Typography, Button, FormControl, Select, MenuItem, CircularProgress } from '@material-ui/core';
import {
    mdiAccountOutline,
    mdiPhoneOutline,
    mdiHomeSearchOutline,
    mdiPackageVariant,
    mdiStateMachine,
    mdiCalendar,
    mdiHomeCityOutline,
    mdiPlus,
    mdiCalendarBlankOutline, mdiDomain, mdiFormatListBulleted, mdiWarehouse
} from '@mdi/js';
import Icon from '@mdi/react';
// helpers
import RenderFilter from '../../utils/listDaynamicFilterHookForm';
import {
    removeEmptyValueObject,
} from '../../utils/helpers';
// components
import Can from '../../components/Can';
import Pagination from '@material-ui/lab/Pagination';
import List from './components/list';

// style
const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        root: {},
        loading: {
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            height: '50vh',
            alignSelf: 'center',
            justifyContent: 'center',
            background: '#ccc',
        },
    }));
const Quarantine = (props: any) => {
    const classes = useStyles();
    const authContext = useContext(AuthContext);
    // states
    const [filters, setFilters] = useState([]);
    const { filtersValues, setFiltersValues } = useQuery({ page: 0, size: 10, 'parcelType.in': ['RECEIPT_TO_WASTAGE', 'RECEIPT_FROM_WASTAGE'] });
    const [openSize, setOpenSize] = React.useState(false as boolean);
    // functions
    const setupFilters = () => {
        Can({
            role: authContext.user.role,
            perform: 'orders:filtersByCenterId',
            yes: () => {
                setFilters([
                    {
                        type: 'input',
                        id: 'customerName.contains',
                        label: 'نام سفارش‌دهنده',
                        icon: mdiAccountOutline,
                    },
                    {
                        type: 'input',
                        id: 'customerMobileNumber.contains',
                        label: 'شماره همراه سفارش‌دهنده',
                        icon: mdiPhoneOutline,
                    },
                    {
                        type: 'input',
                        id: 'id.equals',
                        label: 'شناسه سفارش',
                        icon: mdiPackageVariant,
                    },

                    {
                        type: 'input',
                        id: 'trackingCode.contains',
                        label: 'کد پیگیری',
                        icon: mdiPackageVariant,
                    },
                    {
                        type: 'input',
                        id: 'customerNationalCode.contains',
                        label: 'کد  ملی',
                        icon: mdiPackageVariant,
                    },

                    {
                        type: 'input',
                        id: 'centerName.contains',
                        label: 'نام مرکز',
                        icon: mdiHomeSearchOutline,
                    },

                    {
                        type: 'input',
                        id: 'customerProvinceName.contains',
                        label: 'نام استان',
                        icon: mdiHomeCityOutline,
                    },
                    {
                        type: 'input',
                        id: 'customerCity.contains',
                        label: 'نام شهر',
                        icon: mdiHomeCityOutline,
                    },

                    // {
                    //     type: 'date-picker-time',
                    //     id: 'created.greaterThanOrEqual',
                    //     label: 'تاریخ ثبت سفارش از ',
                    //     icon: mdiCalendar,
                    // },
                    // {
                    //     type: 'date-picker-time',
                    //     id: 'created.lessThanOrEqual',
                    //     label: 'تا تاریخ ثبت سفارش  ',
                    //     icon: mdiCalendar,
                    // },
                    {
                        type: 'date-picker',
                        id: 'deliveryDate.greaterThanOrEqual',
                        label: 'تاریخ ایجاد از ',
                        icon: mdiCalendar,
                    },
                    {
                        type: 'date-picker',
                        id: 'deliveryDate.lessThanOrEqual',
                        label: '  تا تاریخ ایجاد ',
                        icon: mdiCalendar,
                    },
                    {
                        type: 'checkbox',
                        id: 'status.in',
                        label: 'وضعیت سفارش',
                        icon: mdiStateMachine,
                        data: [
                            'ORDERED',
                            'DELIVERED_TO_POST',
                            'DELIVERED_TO_CENTER',
                            'SUPPLIED_IN_CENTER',
                            'PACKAGED',
                            'BUNDLED',
                            'LOADED',
                            'ARRIVED',
                            'DELIVERED',
                            'NOT_DELIVERED',
                            'RETURNED',
                            'SUPPLYING',
                            'CANCELLED',
                        ],
                        translateType: 'Order',
                    },
                    {
                        type: 'checkbox',
                        id: 'paymentType.in',
                        label: 'شیوه پرداخت',
                        icon: mdiStateMachine,
                        data: [
                            'COD', 'ONLINE'
                        ],
                        translateType: 'COD',
                    },
                ]);
            },
            no: () => {
                setFilters([
                    {
                        type: 'checkbox',
                        id: 'parcelType.in',
                        label: 'نوع قبض',
                        icon: mdiCalendarBlankOutline,
                        data: [
                            'RECEIPT_TO_WASTAGE',
                            'RECEIPT_FROM_WASTAGE'
                        ],
                        translateType: 'Quarantine',
                    },
                    {
                        type: 'input',
                        id: 'partnerName.contains',
                        label: 'شرکت',
                        icon: mdiDomain,
                    },
                    {
                        type: 'input',
                        id: 'receiptTitle.contains',
                        label: 'عنوان',
                        icon: mdiFormatListBulleted,
                    },
                    {
                        type: 'input',
                        id: 'id.equals',
                        label: 'شناسه',
                        icon: mdiWarehouse,
                    },

                    // {
                    //   type: 'input',
                    //   id: 'trackingCode.contains',
                    //   label: 'شناسه پیگیری',
                    // },

                    // {
                    //     type: 'input',
                    //     id: 'customerNationalCode.contains',
                    //     label: 'کد  ملی',
                    //     icon: mdiAccountKeyOutline,
                    // },
                    // {
                    //   type: 'input',
                    //   id: 'centerProvince.contains',
                    //   label: 'نام  استان',
                    // },
                    // {
                    //   type: 'input',
                    //   id: 'centerCity.contains',
                    //   label: 'نام  شهر',
                    // },

                    // {
                    //   type: 'date-picker-time',
                    //   id: 'created.greaterThanOrEqual',
                    //   label: 'تاریخ ثبت سفارش از ',

                    // }, {
                    //   type: 'date-picker-time',
                    //   id: 'created.lessThanOrEqual',
                    //   label: 'تا تاریخ ثبت سفارش  ',

                    // },
                    {
                        type: 'date-picker',
                        id: 'shippingDate.greaterThanOrEqual',
                        label: 'تاریخ ایجاد از ',
                        icon: mdiCalendar,
                    },
                    {
                        type: 'date-picker',
                        id: 'shippingDate.lessThanOrEqual',
                        label: '  تا تاریخ ایجاد ',
                        icon: mdiCalendar,
                    },
                    // {
                    //     type: 'checkbox',
                    //     id: 'paymentType.in',
                    //     label: 'شیوه پرداخت',
                    //     icon: mdiStateMachine,
                    //     data: [
                    //         'COD', 'ONLINE'
                    //     ],
                    //     translateType: 'COD',
                    // },
                ]);
            },
        });
    };
    let headCells = [];

    Can({
        role: authContext.user.role,
        perform: 'orders:list:centerName',
        yes: () => {
            headCells = [
                {
                    id: 'customerName',
                    label: 'نام سفارش‌دهنده',
                    type: 'input',
                },
                { id: 'partnerName', label: 'شرکت', type: 'input' },
                { id: 'id', label: 'کد سفارش', type: 'input' },
                { id: 'centerName', label: 'مرکز سفارش', type: 'input' },
                {
                    id: 'deliveryDate',
                    label: 'زمان تحویل',
                    type: 'date-picker',
                },
                {
                    type: 'checkbox',
                    id: 'deliveryType',
                    label: 'نوع ارسال',
                    data: ['COURIER', 'POST', 'EXPRESS_POST', 'SPECIAL_POST', 'VIP'],
                    translateType: 'SendDeliveryType',
                },
                {
                    type: 'checkbox',
                    id: 'status',
                    label: 'وضعیت سفارش',
                    data: [
                        'ORDERED',
                        'DELIVERED_TO_POST',
                        'ASSIGNED',
                        'PICKED',
                        'PACKAGED',
                        'BUNDLED',
                        'LOADED',
                        'ARRIVED',
                        'DELIVERED',
                        'NOT_DELIVERED',
                        'RETURNED',
                        'SUPPLYING',
                        'CANCELLED',
                    ],
                    translateType: 'Order',
                },
            ];
        },
        no: () => {
            headCells = [
                { id: 'id', label: 'نوع قبض', type: 'input' },
                { id: 'partnerName', label: 'شرکت', type: 'input' },
                {
                    id: 'customerName',
                    label: 'عنوان',
                    type: 'input',
                },
                {
                    id: 'customerProvince',
                    label: 'شناسه',
                    type: 'input',
                },
                // {
                //     id: 'customerCity',
                //     label: 'شهر',
                //     type: 'input',
                // },
                {
                    id: 'deliveryDate',
                    label: 'تاریخ ایجاد',
                    type: 'date-picker',
                },
                // {
                //     type: 'checkbox',
                //     id: 'deliveryType',
                //     label: 'نوع ارسال',
                //     data: ['COURIER', 'POST', 'EXPRESS_POST', 'SPECIAL_POST', 'VIP'],
                //     translateType: 'SendDeliveryType',
                // },
                // { id: 'trackingCode', label: 'کد پیگیری', type: 'input' },
                // {
                //     type: 'checkbox',
                //     id: 'paymentType',
                //     label: 'شیوه پرداخت',
                //     data: ['COD', 'ONLINE'],
                //     translateType: 'COD',
                // },
                {
                    type: 'checkbox',
                    id: 'status',
                    label: 'وضعیت',
                    data: [
                        'ORDERED',
                        'DELIVERED_TO_POST',
                        'ASSIGNED',
                        'PICKED',
                        'PACKAGED',
                        'BUNDLED',
                        'LOADED',
                        'ARRIVED',
                        'DELIVERED',
                        'NOT_DELIVERED',
                        'RETURNED',
                        'SUPPLYING',
                        'CANCELLED',
                    ],
                    translateType: 'Order',
                },
            ];
        },
    });
    const head = { headCells };
    const getParcels = () => {
        const { page, size } = filtersValues;
        const { warehouseId } = authContext.user;
        const { partnerId } = authContext.user;

        props.parcelsDispatch({
            ...removeEmptyValueObject(filtersValues),
            partnerId: partnerId ? { equals: partnerId } : undefined, // partner_id => partner_admin role
            sourceWarehouseId: warehouseId ? { equals: warehouseId } : undefined, // WHId
            page,
            size,
        });
    };
    const handleCardClose = () => {
        delete filtersValues['status.in'];
        setFiltersValues({
            ...removeEmptyValueObject(filtersValues),

            page: 0,
            size: 10,
        });
    };
    const handleChangeSizePage = (event: React.ChangeEvent<{ value: unknown }>) => {
        setFiltersValues({ ...filtersValues, page: 0, size: event.target.value });
    };
    const handleChangePage = (
        event: React.ChangeEvent<unknown>,
        page: number
    ) => {
        setFiltersValues({ ...filtersValues, page: page - 1 });
    };
    const handleClose = () => {
        // setOpenConfirmDisable(false);
        // setOpenDialog(false);
        // setOpenAdd(false);
        // setOpenConfirmActive(false);
        setOpenSize(false);
    };
    const filterTranslator = (fieldName: string) => {
        const status = {
            customerName: 'نام سفارش‌دهنده:',
            'customerName.equals': 'نام سفارش‌دهنده:',
            'customerName.contais': 'نام سفارش‌دهنده:',
            centerName: 'انبار:',
            'centerName.equals': 'انبار:',
            'centerName.contains': 'انبار:',
            id: 'شناسه مرسوله:',
            'id.equals': 'شناسه مرسوله:',
            'id.contains': 'شناسه مرسوله:',
            orderId: 'شناسه سفارش:',
            'orderId.equals': 'شناسه سفارش:',
            'orderId.contains': 'شناسه سفارش:',
            deliveryDate: 'تاریخ تحویل',
            'deliveryDate.equals': 'تاریخ تحویل:',
            'deliveryDate.greaterThanOrEqual': 'تاریخ تحویل:',
            'deliveryDate.greaterThan': 'تاریخ تحویل:',
            'deliveryDate.lessThanOrEqual': 'تاریخ تحویل:',
            'deliveryDate.lessThan': 'تاریخ تحویل:',
            packagedDate: 'تاریخ تحویل به لجستیک:',
            'packagedDate.equals': 'تاریخ تحویل به لجستیک:',
            'packagedDate.greaterThanOrEqual': 'تاریخ تحویل به لجستیک:',
            'packagedDate.greaterThan': 'تاریخ تحویل به لجستیک:',
            'packagedDate.lessThanOrEqual': 'تاریخ تحویل به لجستیک:',
            'packagedDate.lessThan': 'تاریخ تحویل به لجستیک:',
            status: 'وضعیت سفارش:',
            'status.in': 'وضعیت سفارش:',
            'status.notIn': 'وضعیت سفارش:',
            partnerName: 'شرکت:',
            'partnerName.equals': 'شرکت:',
            'partnerName.contains': 'شرکت:',
            weight: 'وزن:',
            'weight.equals': 'وزن:',
            'weight.contains': 'وزن:',
            length: 'ابعاد:',
            'length.equals': 'ابعاد:',
            'length.contains': 'ابعاد:',
        };
        return status[fieldName];
    };
    const removeFilterHandler = (fieldName: any) => {
        const filtered = { ...filtersValues };
        delete filtered[fieldName];
        setFiltersValues(filtered);
    };
    // trigger dom

    useEffect(() => {
        getParcels();
        setupFilters();
    }, [filtersValues]);


    return (
        <div className={classes.root} >
            <Grid container spacing={6} alignItems="center" >
                <Grid container item xs={12} sm={6} alignItems="center">
                    <Typography variant="h4" component="h2">
                        {`انبار قرنطینه `}
                    </Typography>
                </Grid>
                <Grid item xs={12} sm={6}>
                    <RenderFilter
                        filters={filters}
                        onFilter={(filtervalues: any) => {
                            setFiltersValues({
                                ...removeEmptyValueObject(filtervalues),
                                page: 0,
                                size: 10,
                            });
                        }}
                        mainFiltersCount={0}
                        baseFilter={{
                            type: 'input',
                            id: 'id.equals',
                            placeholder: 'شناسه قبض',
                        }}
                        filterValues={filtersValues}
                    />
                </Grid>
                <Grid
                    container
                    item
                    xs={12}
                    md={12}
                    direction="row-reverse"
                    alignItems="left"
                >
                    <div >
                        <Link to={`/parcels-quarantine/add`}>
                            <Button
                                variant="contained"
                                color="primary"
                                size="large"
                                startIcon={<Icon path={mdiPlus} size={1} />}
                            >
                                {'ایجاد قبض'}
                            </Button>
                        </Link>
                        {/* 
                        <Can
                            role={user.role}
                            perform="orders:downloadReportCSV"
                            yes={() => (
                                <>
                                    <CSV
                                        ordersDispatch={getAllOrders}
                                        data={allOrders}
                                        filtersValues={filtersValues}
                                        loading={loading}
                                    />
                                    <ExelExport
                                        data={convertArrayItemsToString()}
                                        loading={props.loading}
                                        filtersValues={filtersValues}
                                        handleRequest={getAllOrders}
                                    />
                                </>
                            )}
                        /> */}
                    </div>
                </Grid>
            </Grid>
            <Grid container spacing={3}>
                <Grid item xs={12}>
                    {props.loading ? (
                        <div className={classes.loading}>
                            <CircularProgress />
                        </div>
                    ) : (
                        <>
                            {props.parcelsList.length > 0 ? (
                                <List
                                    data={props.parcelsList}
                                    // users={users}
                                    loading={props.loading}
                                    // handleConfirmCanceleBox={handleOpenConfirmCancele}
                                    // changeStatusOrderWhitId={changeStatusOrderWhitId}
                                    // handleOpenConfirmUpdateState={
                                    //     handleOpenConfirmUpdateState
                                    // }
                                    head={head}
                                    filterVal={filtersValues}
                                    onFilterValue={(filtervalues: any) => {
                                        setFiltersValues({
                                            ...removeEmptyValueObject(filtervalues),
                                            ...filtersValues,
                                            page: 0,
                                            size: 100,
                                        });
                                    }}
                                    removeFilterHandler={removeFilterHandler}
                                    filterLabelTranslator={filterTranslator}
                                />
                            ) : (
                                <Typography variant="h3" component="div">
                                    سفارشی موجود نیست
                                </Typography>
                            )}
                        </>
                    )}
                </Grid>
                <Grid item xs={12} sm={6}>
                    {props.parcelsList.length > 0 && (
                        <FormControl
                            style={{
                                display: 'flex',
                                flexDirection: 'row',
                                alignItems: 'center',
                            }}
                        >
                            <div
                                style={{
                                    marginLeft: '10px',
                                    color: '#8a8a8a',
                                }}
                            >
                                {' '}
                                تعداد نمایش در هر صفحه:
                            </div>
                            <Select
                                open={openSize}
                                onClose={handleClose}
                                onOpen={() => setOpenSize(true)}
                                value={filtersValues.size}
                                onChange={handleChangeSizePage}
                            >
                                <MenuItem value={10}>10</MenuItem>
                                <MenuItem value={20}>20</MenuItem>
                                <MenuItem value={50}>50</MenuItem>
                                <MenuItem value={100}>100</MenuItem>
                            </Select>
                        </FormControl>
                    )}
                </Grid>
                <Grid xs={12} sm={6} container item direction="row-reverse">
                    {props.parcelsList.length > 0 && (
                        <Pagination
                            count={Math.ceil(props.count / filtersValues.size)}
                            color="secondary"
                            page={filtersValues.page + 1}
                            onChange={handleChangePage}
                        />
                    )}
                </Grid>
            </Grid>
        </div>
    )

}


const mapStateToProps = createStructuredSelector<Store, SelectorProps>({
    parcelsList: makeSelectList(),
    count: makeSelectCountList(),
    loading: makeSelectLoading(),
    error: makeSelectError(),
});

function mapDispatchToProps(dispatch: Function) {
    return {
        parcelsDispatch: (payload: Object) => dispatch(getParcelsAction(payload)),
        // updateWarehouseDispatch: (payload: PayloadUpdate) =>
        //     dispatch(updateParcelsActions(payload)),
        // createParcelsDispatch: (payload: PayloadCreate) =>
        //     dispatch(createParcelsActions(payload)),
        // deleteParcelDispatch: (payload: { id: number }) =>
        //     dispatch(deleteParcelAction(payload)),
        // updateParcelsStatusDispatch: (payload: {
        //     id: number;
        //     body: string;
        //     pagination: object;
        // }) => dispatch(updateParcelsStatusActions(payload)),
    };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);
export default compose(withConnect)(Quarantine);
// export default Quarantine;